// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    CheckboxFieldDefinition,
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import * as React from "react";

const DocumentsForValvesCustomers: CheckboxFieldDefinition = {
    name: "documentsForValvesCustomers",
    displayName: "For Valves Customers",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
    tooltip: "If selected, this page will be visible to customers with the 'Valves' Document Library Access custom Property.",
};

const DocumentsForPumpsCustomers: CheckboxFieldDefinition = {
    name: "documentsForPumpsCustomers",
    displayName: "For Pumps Customers",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
    tooltip: "If selected, this page will be visible to customers with the 'Pumps' Document Library Access custom Property.",
};

const DocumentsForCyclonesCustomers: CheckboxFieldDefinition = {
    name: "documentsForCyclonesCustomers",
    displayName: "For Cyclones Customers",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
    tooltip: "If selected, this page will be visible to customers with the 'Cyclones' Document Library Access custom Property.",
};

const RestrictedDocumentLibraryPage: React.FunctionComponent<PageProps> = ({ id }) => (
    <MobiusPage>
        <Zone contentId={id} zoneName="Content" />
    </MobiusPage>
);

const pageModule: PageModule = {
    component: RestrictedDocumentLibraryPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedChildren: [],
        fieldDefinitions: [
            DocumentsForValvesCustomers,
            DocumentsForPumpsCustomers,
            DocumentsForCyclonesCustomers,
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
